export enum MailJobStatus
{
    Open    = 0,
    Printed = 1,
    Closed  = 2
}

export const MailJobStatusMetadata = {
    '0' : {
        display: 'Open',
        value: 0
    },
    '1' : {
        display: 'Printed',
        value: 1
    },
    '2' : {
        display: 'Closed',
        value: 2
    }
}